<div >

    <div> 
      <div class="row multi-steps-wrap" *ngIf="status=='Cancelled'">
        <ul class="list-unstyled multi-steps">
            <!-- <span class="bar"></span> -->
          <li class="job-status job-created" [ngClass]="{'job-inprogress is-active negative': status == 'Created'}" >Created</li>
          <!-- <span class="bar"></span> -->
          <li class="job-status job-closed"   [ngClass]="{'job-inprogress is-active declined': status == 'Cancelled'}" >Cancelled</li>
          
          <li class="job-status job-packed" [ngClass]="{'job-inprogress is-active negative': status == 'LA approved 1'}" >LA Approved 1</li>
          <!-- <span class="bar"></span> -->
          <li class="job-status job-completed"  [ngClass]="{'job-inprogress is-active negative': status == 'LA approved 2'}" >LA Approved 2</li>
          <li class="job-status job-closed"  [ngClass]="{'job-inprogress is-active negative': status == 'Supervisor Approved'}" >Supervisor Approved</li>
          <li class="job-status job-closed"  [ngClass]="{'job-inprogress is-active negative': status == 'Print pass'}" >Print Pass</li>
          <li class="job-status job-closed"  [ngClass]="{'job-inprogress is-active negative': status == 'Received'}" >Received</li>
          
        </ul>
      </div>
      <div class="row multi-steps-wrap" *ngIf="status!='Cancelled'">
        <ul class="list-unstyled multi-steps">
            <!-- <span class="bar"></span> -->
          <li class="job-status job-created" [ngClass]="{'job-inprogress is-active negative': status == 'Created'}" >Created</li>
          <!-- <span class="bar"></span> -->
          <li class="job-status job-packed" [ngClass]="{'job-inprogress is-active negative': status == 'LA approved 1'}" >LA Approved 1</li>
          <!-- <span class="bar"></span> -->
          <li class="job-status job-completed"  [ngClass]="{'job-inprogress is-active negative': status == 'LA approved 2'}" >LA Approved 2</li>
          <li class="job-status job-closed"  [ngClass]="{'job-inprogress is-active negative': status == 'Supervisor Approved'}" >Supervisor Approved</li>
          <li class="job-status job-closed"  [ngClass]="{'job-inprogress is-active negative': status == 'Print pass'}" >Print Pass</li>
          <li class="job-status job-closed"  [ngClass]="{'job-inprogress is-active negative': status == 'Received'}" >Received</li>
          
        </ul>
      </div>

      
</div>
</div>
